import {ReliabilityEngineerAreaDashboard} from '@features/reliability-engineer-dashboard'
import {useRouteSegmentsAreaNavigation} from '@widgets/area-dashboard'

import {LocationBreadcrumbs} from '../../components'
import {useHrocMapMarkersData} from '../../hooks'
import {AREA_ROUTE_SEGMENTS, RELIABILITY_ENGINEER_DASHBOARD} from '../../routing'

export const AreaReliabilityEngineerDashboard = () => (
  <ReliabilityEngineerAreaDashboard
    dashboardRoute={RELIABILITY_ENGINEER_DASHBOARD}
    navigation={useRouteSegmentsAreaNavigation(AREA_ROUTE_SEGMENTS)}
    fallbackBreadcrumbs={<LocationBreadcrumbs sx={{ml: 0}} />}
    useMapMarkersDataHook={useHrocMapMarkersData}
  />
)
